module.exports = __webpack_public_path__ + "img/auth-doctor-banner.6315da5e.jpeg";